export default __webpack_public_path__ + "static/media/investmentHome.8712fb3f.svg";